import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1e3a5f',
            color: '#fff',
            borderRadius: '8px',
          },
          success: {
            style: { background: '#22c55e' },
            iconTheme: { primary: '#fff', secondary: '#22c55e' },
          },
          error: {
            style: { background: '#ef4444' },
            iconTheme: { primary: '#fff', secondary: '#ef4444' },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
